import React from 'react';

import {transparentize} from 'polished';
import ReactTooltip, {TooltipProps} from 'react-tooltip';
import styled from 'styled-components';

import {colors, font} from '@app/styles/theme';

interface Props {
    effect?: TooltipProps['effect'];
    place?: TooltipProps['place'];
    backgroundColor?: string;
    textColor?: string;
    id?: string;
    children?: React.ReactNode;
}

const TooltipRoot = ({
    effect = 'solid',
    place = 'right',
    backgroundColor = transparentize(0.7, colors.black),
    textColor = colors.white,
    children,
    ...otherProps
}: Props) => (
    <ReactTooltip
        effect={effect}
        place={place}
        backgroundColor={backgroundColor}
        textColor={textColor}
        {...(otherProps.id && {id: otherProps.id})}
        {...otherProps}
    >
        {children}
    </ReactTooltip>
);

export const Tooltip = styled(TooltipRoot)<{additionalStyles?: string}>`
    font-family: ${font.family.primary};
    text-align: center;

    ${(p) => p.additionalStyles ?? ''};
`;
